<template>
  <div class="banner perBan">
    <img :src="banners.image" alt="">
    <div class="w1440">
      <div class="txt">
        <p class="fnt_52">
          {{ globalDataArray.siteTemplateLanguage.banner_welcome }}

          <template
            v-if="saitiAccessInfo.nickname != '' && saitiAccessInfo.nickname != null && saitiAccessInfo.nickname != undefined"
          >
            {{ saitiAccessInfo.nickname }}
          </template>

          <template
            v-else-if="saitiAccessInfo.username != '' && saitiAccessInfo.username != null && saitiAccessInfo.username != undefined"
          >
            {{ saitiAccessInfo.username }}
          </template>
        </p>
        <span
          class="fnt_18 mail"
          v-if="saitiAccessInfo.email != '' && saitiAccessInfo.email != null && saitiAccessInfo.email != undefined"
        >
          {{ saitiAccessInfo.email }}
        </span>
        <span
          class="fnt_18"
          v-else-if="saitiAccessInfo.phone != '' && saitiAccessInfo.phone != null && saitiAccessInfo.phone != undefined"
        >
          {{ saitiAccessInfo.phone }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { getAdList } from '@/api/api'
import Cookies from 'js-cookie'
export default {
  name: 'PersonHeader',
  data() {
    return {
      saitiAccessInfo: {},
      banners: {}
    }
  },
  mounted() {
    this.getAdList()
    this.init()
  },
  methods: {
    init() {
      if (Cookies.get('saiti_access_info') != '' && Cookies.get('saiti_access_info') != undefined && Cookies.get('saiti_access_info') != null) {
        this.saitiAccessInfo = JSON.parse(Cookies.get('saiti_access_info'))
        console.log(this.saitiAccessInfo, 'llll')
      }
    },
    getAdList() {
      const that = this
      const adParam = 'alias=person_banner'
      getAdList(adParam).then(res => {
        if (res.success) {
          that.banners = res.result[0]
        }
      })
    }
  }
}
</script>
